module.exports = __webpack_public_path__ + "img/C.fac7f105.png";